import styled from "styled-components";

const FlightRoute = styled.div`
  padding: 18px;
  background-color: ${({ theme }) => theme.colors.journeySectionBackground};
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    padding: 16px;
    border: none;
  }
`;

export default FlightRoute;
